// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title_Xyc+3"};